import { FC } from "react"
import { useHeroActiveEffects } from "@/hooks/useHeroActiveEffects"
import { ActiveEffectList } from "@/modals/constructor/hero/HeroModal/ui/ActiveEffectList"

export const ActiveEffectsSection: FC = () => {
  const effects = useHeroActiveEffects()

  if (effects.length === 0) {
    return null
  }

  return <ActiveEffectList effects={effects} />
}
